<template>
  <el-dialog
    title="编辑合作企业扩展信息"
    :visible.sync="visible"
    width="1100px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="110px">
      <el-row :gutter="6">
        <el-col :span="9">
          <el-form-item
            label="企业名称："
            prop="vendorName">
            {{ info.vendorName }}
          </el-form-item>
          <el-form-item
            label="企业简称："
            prop="vendorShortname">
            <el-input
              v-model="info.vendorShortname"
              show-word-limit
              :maxlength="6"></el-input>
          </el-form-item>
          <el-form-item
            label="企业标签："
            prop="labels">
            <custom-tag-select
              v-model="info.labels"
              k="company_brand_image" />
          </el-form-item>
          <el-form-item
            label="经营范围："
            prop="companyBusinessCategorys">
            <custom-tag-select
              v-model="info.companyBusinessCategorys"
              k="company_business_category" />
          </el-form-item>
          <el-form-item
            label="企业简介："
            prop="vendorDesc">
            <el-input
              v-model="info.vendorDesc"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 6}"
              show-word-limit
              :maxlength="100"></el-input>
          </el-form-item>
          <el-form-item
            label="企业LOGO："
            prop="coverImage">
            <upload-with-crop
              v-model="info.coverImage"
              :isLt2M="500"
              :fixedNumber="[1,1]"
              :autoCropWidth="100"
              :autoCropHeight="100"></upload-with-crop>
          </el-form-item>
        </el-col>
        <el-col :span="15">
          <el-form-item
            label="图文详情："
            prop="descImages">
            <desc-images
              v-model="info.descImages"
              edit></desc-images>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消 </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit"> 确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import DescImages from '../../../components/public/desc-images.vue'
import UploadWithCrop from '../../../components/public/upload-with-crop.vue'
import CustomTagSelect from './custom-tag-select.vue'
export default {
  name: 'EditVendorExtraModal',
  components: { UploadWithCrop, DescImages, CustomTagSelect },
  props: {
    callback: { type: Function }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: { vendorId: null, vendorName: '', vendorShortname: '', vendorDesc: '', coverImage: [], descImages: [], labels: [], companyBusinessCategorys: [] },
      rules: {
        coverImage: [{ required: true, message: '请上传企业Logo', trigger: 'change' }],
        descImages: [{ required: true, message: '请上传企业图文信息', trigger: 'change' }],
        vendorShortname: [
          { required: true, message: '请输入企业简称', trigger: 'blur' },
          { max: 6, message: '企业简称最多 6 个字符', trigger: 'blur' }
        ],
        vendorDesc: [
          { required: true, message: '请输入企业简介', trigger: 'blur' },
          { max: 100, message: '企业简介最多 100 个字符', trigger: 'blur' }
        ],
        labels: [{ required: true, message: '请选择企业标签', trigger: 'change' }],
        companyBusinessCategorys: [{ required: true, message: '请选择经营范围', trigger: 'change' }]
      }
    }
  },
  methods: {
    handleClosed() {
      this.info = { vendorId: null, vendorName: '', unifiedCreditCode: '', businessLicenceFile: [], area: [], vendorAddress: '', vendorPerson: '', vendorPhone: '' }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const { coverImage, descImages } = this.info
          this.$store.dispatch(`account/updatevendor`, {
            payload: { ...this.info, coverImage: this.$stringfyImage(coverImage), descImages: this.$stringfyImage(descImages) },
            success: () => {
              this.loading = false
              // this.visible = false
              this.$message.success('更新成功')
              this.$emit('fetch')
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    init(options = {}) {
      this.info = { ...this.info, ...options }
      this.visible = true
    }
  }
}
</script>
